import script from "./GearCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GearCard.vue?vue&type=script&setup=true&lang=js"

import "./GearCard.vue?vue&type=style&index=0&id=72e39c93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e39c93"]])

export default __exports__